import type * as React from 'react';

import { FieldContext } from './FieldContext';
import { FieldControllerContext } from './FieldControllerContext';

/**
 * Isolate a field, useful to use control in a field without linking it to a form.
 */
export function IsolateField(props: { children: React.ReactNode }) {
    return (
        <FieldControllerContext.Provider value={null}>
            <FieldContext.Provider value={null}>{props.children}</FieldContext.Provider>
        </FieldControllerContext.Provider>
    );
}
